"use client";

import { FC, useMemo } from "react";
import { useLocale, useTranslations } from "next-intl";

import { OfficeRecord } from "@graphql/types/graphql";
import { getLink } from "utils";

import { ImageTeaser } from "./templates/ImageTeaser";
import { Locale } from "consts/locale";

interface Props {
  office: OfficeRecord;
}

export const OfficeTeaser: FC<Props> = ({ office }) => {
  const t = useTranslations("common");
  const locale = useLocale() as Locale;

  const image = office.officeImage?.responsiveImage ?? office.introImage?.responsiveImage;

  return (
    <ImageTeaser
      link={office.externalLink ? undefined : getLink(office, locale)}
      externalLink={office.externalLink || undefined}
      image={image}
      title={office.title}
      addresses={office.officeLocations}
      buttonLabel={t("more-details")}
    />
  );
};
